import React from "react";
import PolicyEmbed from "./PolicyEmbed";

export default function CookiePolicyPage() {

  return <PolicyEmbed title="Cookie Policy"
                      src="https://app.termly.io/policy-viewer/policy.html?policyUUID=2757be5f-88df-412c-a470-c9d43c875330"
                      height={3850} />

}
